import { useState, useEffect } from 'react';
import { fetchMeter, fetchMeterFiles } from '../services/meter.api';

const normalizeFiles = (rows) =>
  (Array.isArray(rows) ? rows : []).map((x) => ({
    ReadingDate: x.ReadingDate,
    Status: x.status,
    filename: x.filename,
    'Loaded Date': x.loadedDate,
  }));

export function useMeterDetails(meterNumber, opts = {}) {
  const { unit, evn } = opts ?? {};

  const [meterData, setMeterData] = useState(null);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!meterNumber) return;

    let alive = true;

    (async () => {
      try {
        setLoading(true);

        const [meterResult, filesResult] = await Promise.allSettled([
          fetchMeter(meterNumber, { unit, evn }),
          fetchMeterFiles(meterNumber, unit, evn),
        ]);

        if (!alive) return;

        if (meterResult.status === 'fulfilled') {
          setMeterData(meterResult.value ?? null);
        } else {
          console.error('useMeterDetails meter:', meterResult.reason);
          setMeterData(null);
        }

        if (filesResult.status === 'fulfilled') {
          setFiles(normalizeFiles(filesResult.value));
        } else {
          console.error('useMeterDetails files:', filesResult.reason);
          setFiles([]);
        }
      } catch (err) {
        if (!alive) return;
        console.error('useMeterDetails:', err);
        setMeterData(null);
        setFiles([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [meterNumber, unit, evn]);

  return { meterData, files, loading };
}
